import { z } from "zod";
import { ValidationUtils } from "./utils";

export const EstimateSchema = z.object(
    {
        dealTypeCode: ValidationUtils.nonEmpty(),
        installedSystemCode: ValidationUtils.nonEmpty(),
        client: z.object({
            name: ValidationUtils.nonEmpty(),
            billingZip: ValidationUtils.nonEmpty(),
            billingState: ValidationUtils.nonEmpty(),
            email: z.preprocess(
                (val) => (typeof val === "string" ? val.trim() : val),
                z.union([z.literal(""), ValidationUtils.validEmail()]),
            ),
        }),
        colorCode: ValidationUtils.nonEmpty(),
        shippingZip: ValidationUtils.nonEmpty(),
        shippingState: ValidationUtils.nonEmpty(),

        managerCode: z.object({
            code: ValidationUtils.nonEmpty(),
            title: ValidationUtils.nonEmpty(),
        }),
    },
    {
        message:
            "Validation error\nSome of the required fields are not filled correctly",
    },
);
